import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'
import { setModal } from '../../../redux/modalSlice'
import { useForm, Controller } from 'react-hook-form'
import { DateFormat, CurrencyFormat, buildQueryString } from '../../../helpers/formatting'
import { reactSelectClassNames } from '../../../helpers/react-select-styles'
import Select from 'react-select'
import { selectDropdownOptions, selectDropdowns } from '../../../redux/dropdownSlice'
import { setChangeMade } from '../../../redux/paymentSchedulePanelSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import PaymentDatePicker from "../../../components/PaymentDatePicker";
import { format } from 'date-fns';
import ManagerApprovalIcons from "../../../components/elements/ManagerApprovalIcons";

export default function PayoffPayment(props) {
  const { loanId, refreshPaymentSchedule, navigateSlider, currentDate, customerInfo, paymentMethodHelperText, promotions } = props
  const requesting = useRef(false)
  const request = useRequest()
  const dispatch = useDispatch()
  const [responseData, setResponseData] = useState([])
  const { register, handleSubmit, control, watch, setValue, formState: { errors } } = useForm();
  const today = new Date().toISOString().split("T")[0];
  const [quote, setQuote] = useState()
  const [payoff_interest, setPayoffInterest] = useState()
  const [late_fee, setLateFee] = useState()
  const [nsf_fee, setNSFFee] = useState()
  const [maxPayoffDate, setMaxPayoffDate] = useState(today)
  const [saving, setSaving] = useState(false)
  const [savingQuote, setSavingQuote] = useState(false)
  const [isFirstTime, setIsFirstTime] = useState(false)
  const [enableScheduleButton, setEnableScheduleButton] = useState(false)
  const [enableQuoteButton, setEnableQuoteButton] = useState(false)
  const dropdownOptions = useSelector(selectDropdownOptions);
  const watchedPaymentDate = watch('payment_date');
  const watchedPrincipalDiscount = watch('principal_discount')
  const watchedInterestDiscount = watch('interest_discount')
  const watchedLateFeeDiscount = watch('late_fee_discount')
  const watchedNSFFeeDiscount = watch('nsf_fee_discount')
  const watchedDiscountReasonDDO = watch('discount_reason_dropdown_option_id')
  const [paymentMethodDdoId, setPaymentMethodDdoId] = useState(null);
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const paymentMethodACHId = dropdownOptions.find((o) => o?.code_key === "payment_method_ach")?.id;
  const paymentMethodDebitCardId = dropdownOptions.find((o) => o?.code_key === "payment_method_debit_card")?.id;
  const dropdowns = useSelector(selectDropdowns);
  const discountReason = dropdowns.data.filter((o) => o.code_key === 'discount_reason')[0];
  const discountReasonOptions = dropdownOptions.filter((o) => o.dropdown_id === discountReason.id && o.optional_value_1 === 'TRUE').map((o) => ({ label: o.name, value: o.id, codeKey: o.code_key }));
  const [showManagerApproval, setShowManagerApproval] = useState(false);

  // all discount
  const [discountType, setDiscountType] = useState("amount")
  const [discountSign, setDiscountSign] = useState("$")
  const [discountInfoText, setDiscountInfoText] = useState("")

  // all fields for table
  const [finalPrincipalDiscount, setFinalPrincipalDiscount] = useState(0)
  const [finalInterestDiscount, setFinalInterestDiscount] = useState(0)
  const [finalLateFeeDiscount, setFinalLateFeeDiscount] = useState(0)
  const [finalNSFFeeDiscount, setFinalNSFFeeDiscount] = useState(0)
  const [hasAgentDiscount, setHasAgentDiscount] = useState(false)

  useEffect(() => {
    let hasChange = false;
    if (paymentMethodDdoId !== defaultPaymentMethod?.value) {
      hasChange = true;
    }
    dispatch(setChangeMade(hasChange))
  }, [paymentMethodDdoId]);

  useEffect(() => {
    if (currentDate) {
      setSelectedDate(new Date((`${currentDate}`)))
    }
  }, [currentDate])

  useEffect(() => {
    if (!isFirstTime) {
      getPayoffQuote(loanId)
      setIsFirstTime(true)
    } else if (selectedDate) {
      setEnableQuoteButton(true)
      setEnableScheduleButton(false)
    } else if (selectedDate === null) {
      setSelectedDate(new Date())
      getPayoffQuote(loanId)
    }
  }, [selectedDate])

  useEffect(() => {
    let payOffAmount = 0;
    let totalDiscount = (watchedPrincipalDiscount + watchedInterestDiscount + watchedLateFeeDiscount + watchedNSFFeeDiscount);
    if (responseData.payoff_amount) {
      // If a discount is sent to the backend, it will reset any existing discounts in the payoff amount, so only start with prediscount amounts if there are no other added discounts
      if (+totalDiscount === 0) {
        payOffAmount = (+responseData.payoff_amount.postdiscount.principal + +responseData.payoff_amount.postdiscount.interest + +responseData.payoff_amount.postdiscount.nsf_fee + +responseData.payoff_amount.postdiscount.late_fee + +responseData.payoff_amount.postdiscount.loan_fee);
        setFinalPrincipalDiscount(0)
        setFinalInterestDiscount(0)
        setFinalLateFeeDiscount(0)
        setFinalNSFFeeDiscount(0)
      } else {
        payOffAmount += responseData.payoff_amount.prediscount.principal;
        payOffAmount += responseData.payoff_amount.prediscount.interest;
        payOffAmount += responseData.payoff_amount.prediscount.loan_fee;
        payOffAmount += responseData.payoff_amount.prediscount.late_fee;
        payOffAmount += responseData.payoff_amount.prediscount.nsf_fee;

        if (discountType === "amount") {
          setFinalPrincipalDiscount(watchedPrincipalDiscount)
          setFinalInterestDiscount(watchedInterestDiscount)
          setFinalLateFeeDiscount(watchedLateFeeDiscount)
          setFinalNSFFeeDiscount(watchedNSFFeeDiscount)

          payOffAmount -= watchedNSFFeeDiscount;
          payOffAmount -= watchedInterestDiscount;
          payOffAmount -= watchedLateFeeDiscount;
          payOffAmount -= watchedPrincipalDiscount;
        } else if (discountType === "percent") {
          setFinalPrincipalDiscount((watchedPrincipalDiscount / 100) * responseData.payoff_amount.prediscount.principal)
          setFinalInterestDiscount((watchedInterestDiscount / 100) * responseData.payoff_amount.prediscount.interest)
          setFinalLateFeeDiscount((watchedLateFeeDiscount / 100) * responseData.payoff_amount.prediscount.late_fee)
          setFinalNSFFeeDiscount((watchedNSFFeeDiscount / 100) * responseData.payoff_amount.prediscount.nsf_fee)

          payOffAmount -= (watchedNSFFeeDiscount / 100) * responseData.payoff_amount.prediscount.nsf_fee;
          payOffAmount -= (watchedInterestDiscount / 100) * responseData.payoff_amount.prediscount.interest;
          payOffAmount -= (watchedLateFeeDiscount / 100) * responseData.payoff_amount.prediscount.late_fee;
          payOffAmount -= (watchedPrincipalDiscount / 100) * responseData.payoff_amount.prediscount.principal;
        }
      }
    }
    setQuote(Number.parseFloat(payOffAmount).toFixed(2))
    setShowManagerApproval(
      responseData?.requires_manager_approval && (
        (parseFloat(watchedPrincipalDiscount) ?? 0) + (parseFloat(watchedInterestDiscount) ?? 0) + (parseFloat(watchedLateFeeDiscount) ?? 0) + (parseFloat(watchedNSFFeeDiscount) ?? 0)
      ) > responseData.max_discount_without_approval
    );
  }, [watchedNSFFeeDiscount, watchedInterestDiscount, watchedLateFeeDiscount, watchedPrincipalDiscount, responseData, discountType]);

  useEffect(() => {
    if (quote) {
      if (watchedPrincipalDiscount > 0 || watchedNSFFeeDiscount > 0 || watchedInterestDiscount > 0 || watchedLateFeeDiscount > 0) {
        setEnableScheduleButton(!!watchedDiscountReasonDDO)
      } else {
        setEnableScheduleButton(true);
        setShowManagerApproval(false);
      }
    } else {
      setEnableScheduleButton(false);
    }
  }, [watchedDiscountReasonDDO]);

  useEffect(() => {
    getPayoffQuote(loanId);
  }, [watchedDiscountReasonDDO, paymentMethodDdoId]);

  const getPayoffQuote = async (loanId) => {
    if (requesting.current) return;
    setEnableScheduleButton(false);
    setSavingQuote(true)
    requesting.current = true;

    let pDate = null;
    if (selectedDate) {
      if (!isFirstTime && currentDate) {
        pDate = format(new Date(currentDate), 'yyyy-MM-dd');
      } else {
        pDate = format(selectedDate, 'yyyy-MM-dd');
      }
    }

    let params = {
      payment_date: pDate,
      current_date: currentDate,
      discount_reason_dropdown_option_id: watchedDiscountReasonDDO?.value,
      payment_method_dropdown_option_id: paymentMethodDdoId
    }

    try {
      let endpoint = `${process.env.REACT_APP_API_DOMAIN}/loan/${loanId}/payment_schedule/payoff_info` + buildQueryString(params);

      request.setEndpoint(endpoint)
      const response = await request.get()
      setResponseData(response?.data?.data);
      setMaxPayoffDate(response?.data?.data?.max_payoff_date)
      let payOffAmount = 0;
      if (response?.data?.data?.payoff_amount) {
        payOffAmount += response.data.data.payoff_amount.principal;
        payOffAmount += response.data.data.payoff_amount.interest;
        payOffAmount += response.data.data.payoff_amount.loan_fee;
        payOffAmount += response.data.data.payoff_amount.late_fee;
        payOffAmount += response.data.data.payoff_amount.nsf_fee;
      }
      setQuote(payOffAmount)
      setEnableQuoteButton(false)
      requesting.current = false;
      if (!defaultPaymentMethod) {
        const paymentMethod = dropdownOptions.filter((o) => response?.data?.data?.default_payment_method_dropdown_option_id === o.id).map((o) => ({ label: o.name, value: o.id }))[0];
        setDefaultPaymentMethod(paymentMethod);
        setPaymentMethodDdoId(paymentMethod?.value)
      }
      setSavingQuote(false)

      if (response.data.data.min_payoff_date) {
        const todaysDate = new Date();
        const formatSelectedDate = format(selectedDate, 'yyyy-MM-dd');
        const formatTodaysDate = format(todaysDate, 'yyyy-MM-dd');
        if (formatSelectedDate === formatTodaysDate && response.data.data.min_payoff_date > formatTodaysDate) {
          setSelectedDate(new Date(`${response.data.data.min_payoff_date} 00:00:00`));
        } else {
          setEnableScheduleButton(true);
        }
      }
    } catch (error) {
      setSavingQuote(false)
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }))
      requesting.current = false;
    }
  }

  useEffect(() => {
    setHasAgentDiscount((finalPrincipalDiscount + finalInterestDiscount + finalLateFeeDiscount + finalNSFFeeDiscount) > 0)
  }, [finalPrincipalDiscount, finalInterestDiscount, finalNSFFeeDiscount, finalLateFeeDiscount])

  const areYouSure = () => {
    dispatch(setModal({
      is_active: true,
      type: 'are_you_sure',
      options: {
        title: "Are you sure?",
        description: "The customer's interest free promotion will only be redeemed if they schedule a payoff before their first payment is due.",
        actionLabel: "Continue",
        callMethod: () => {
          handleSubmit(onSubmit)();
        }
      }
    }));
  };

  const clickConfirmation = () => {
    const interestFreePromo = promotions?.[0]?.name === 'Free Interest Promotion'
    const formattedSelectedDate = format(selectedDate, 'yyyy-MM-dd');
    if (interestFreePromo && formattedSelectedDate === responseData?.max_payoff_date) {
      areYouSure();
    } else {
      handleSubmit(onSubmit)();
    }
  }

  const onSubmit = async (formData) => {
    if (+finalPrincipalDiscount > 0 || +finalInterestDiscount > 0 || +finalLateFeeDiscount > 0 || +finalNSFFeeDiscount > 0) {
      if (!watchedDiscountReasonDDO) {
        dispatch(setNotification({ type: 'error', body: "Please select a discount reason" }))
        return
      }
    }

    if (paymentMethodACHId == paymentMethodDdoId && customerInfo?.ach_revocation_active) {
      dispatch(
        setModal({
          is_active: true,
          type: 'allow_ach_payments_modal',
          options: { customerId: customerInfo.id, hasBkConfirmed: customerInfo?.has_bk_confirmed }
        })
      )
    } else {
      setSaving(true)
      request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/loan/${loanId}/payment_schedule/payoff`)
      try {
        if (currentDate !== null) {
          formData['current_date'] = currentDate;
        }
        formData.payment_date = format(selectedDate, 'yyyy-MM-dd');
        formData.payment_method_dropdown_option_id = formData.payment_method_dropdown_option_id.value;
        formData.discount_reason_dropdown_option_id = formData.discount_reason_dropdown_option_id?.value || null;

        // change the paramater name to match the API
        formData.principal_discount = Number.parseFloat(finalPrincipalDiscount).toFixed(2);
        formData.interest_discount = Number.parseFloat(finalInterestDiscount).toFixed(2);
        formData.late_fee_discount = Number.parseFloat(finalLateFeeDiscount).toFixed(2);
        formData.nsf_fee_discount = Number.parseFloat(finalNSFFeeDiscount).toFixed(2);

        const response = await request.post(formData)
        if (response.status === 200 || response.status === 201) {
          setSaving(false)
          dispatch(setNotification({ type: 'success', body: '' }))
          navigateSlider("form_submit")
          refreshPaymentSchedule()
        } else {
          setSaving(false)
          dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
        }
      } catch (error) {
        setSaving(false)
        const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
        dispatch(setNotification({ type: 'error', body: errorMessage }))
      }
    }
  };

  const checkChangesMade = () => {
    navigateSlider("");
  }

  useEffect(() => {
    if (discountType === "amount") {
      setDiscountSign("$")
      setDiscountInfoText("Discounting by amount selected")
    } else if (discountType === "percent") {
      setDiscountSign("%")
      setDiscountInfoText("Discounting by percentage selected")
    }
  }, [discountType])

  return (
    <div className="pl-5 py-3">
      {responseData.length == 0 && <div className="is-italic" style={{ textAlign: "center", padding: "20px", color: "grey" }}>--- Loading ---</div>}

      {responseData.length != 0 && (
        <form onSubmit={handleSubmit(onSubmit)} id="payoff_payment_form">
          <p className="title is-5">Payoff Payment</p>
          <table className="table is-narrow table-payment-schedule-panel">
            <thead>
              <tr>
                <td>
                  {paymentMethodDdoId == paymentMethodDebitCardId ? (
                    <><strong>Debit Card Number:</strong> ###########{customerInfo?.debit_card_number_last_four}</>
                  ) : (
                    <><strong>Bank Name:</strong> {customerInfo?.bank_name}, <strong>Account Number:</strong> ###########{customerInfo?.bank_account_number_last_four}</>
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  Payment Method <span
                    className={'lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-right has-tooltip-primary has-text-weight-normal'}
                    data-tooltip={paymentMethodHelperText}
                  >
                    <FontAwesomeIcon icon={faQuestionCircle} className="has-text-link" />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ zIndex: 15, position: 'relative' }}>
                  <Controller
                    name="payment_method_dropdown_option_id"
                    defaultValue={defaultPaymentMethod}
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        {...register('payment_method_dropdown_option_id')}
                        options={dropdownOptions.filter((o) => responseData?.payment_method_dropdown_option_ids.includes(o.id)).map((o) => ({
                          label: o.name,
                          value: o.id
                        }))}
                        isSearchable={false}
                        classNames={reactSelectClassNames()}
                        onChange={(val) => {
                          field.onChange({ label: val?.label, value: val?.value })
                          setPaymentMethodDdoId(val?.value)
                        }}
                        menuPosition="fixed"
                        form="payoff_payment_form"
                        styles={{ container: (base) => ({ ...base, width: '100%' }), menu: ({ ...css }) => ({ ...css, width: '100%' }) }}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table className="table is-narrow table-payment-schedule-panel">
            <tbody>
              <tr>
                <td colSpan={1}>Date</td>
                <td colSpan={1}>
                  <Controller
                    name="payment_date"
                    control={control}
                    render={({ field }) => (
                      <PaymentDatePicker
                        paymentMethodDdoId={paymentMethodDdoId}
                        min={`${responseData?.min_payoff_date}T00:00:00`}
                        max={`${responseData?.max_payoff_date}T00:00:00`}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                      />
                    )}
                  />
                  <span className="pl-2">Can&apos;t go past <DateFormat dateString={maxPayoffDate} /></span>
                </td>
                <td colSpan={3}>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className="pt-3">
                  <div className="is-inline-block" style={{ width: '22%' }}>
                    <b>Payoff Quote* </b>
                    {quote !== false ? (<CurrencyFormat value={quote} />) : '-'}
                  </div>
                  <button
                    type="button"
                    className="button is-link is-small mr-1"
                    onClick={() => getPayoffQuote(loanId)}
                    disabled={(savingQuote && 'disabled') || (!enableQuoteButton && 'disabled')}
                  >
                    <span className="mx-3">{savingQuote ? 'Getting Quote' : 'Get Quote'}</span>
                  </button>
                </td>
                <td colSpan={1}></td>
              </tr>

              <tr>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table className="table is-narrow table-payment-schedule-panel" style={{ maxWidth: "2000px" }}>
            <thead>
              <tr>
                <td className="pt-5" colSpan={5}>
                  <b>Discount Type</b>: <span className="has-text-primary">{discountInfoText}</span>
                  <div>
                    <div className="control">
                      <label className="radio mr-3">
                        <input name="discount_type" value="amount" type="radio" onChange={() => setDiscountType("amount")} checked={discountType === "amount"} /> Amount ($)
                      </label> OR <label className="radio ml-3">
                        <input name="discount_type" value="percent" type="radio" onChange={() => setDiscountType("percent")} checked={discountType === "percent"} /> Percent (%)
                      </label>
                    </div>
                  </div>
                  <p></p>
                </td>
                <td colSpan={2}></td>
              </tr>
              <tr>
                <th className="pr-2 py-2">Payoff Discounts</th>
                <th className="pr-2 py-2" style={{ width: '250px' }}>Principal {discountSign}</th>
                <th className="pr-2 py-2" style={{ width: '250px' }}>Interest {discountSign}</th>
                <th className="pr-2 py-2" style={{ width: '250px' }}>Late Fee {discountSign}</th>
                <th className="pr-2 py-2" style={{ width: '250px' }}>NSF Fee {discountSign}</th>
                <th colSpan={2}></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td className="pr-2 py-2">
                  <Controller
                    name={`principal_discount`}
                    control={control}
                    defaultValue={0}
                    render={({ field }) => (
                      <input
                        {...field}
                        {...register(`principal_discount`)}
                        name={`principal_discount`}
                        className="input is-small"
                        style={{ width: '125px' }}
                        type="number"
                        step="0.01"
                        form="payoff_payment_form"
                        disabled={responseData.payoff_amount.principal === 0}
                        max={discountType == 'amount' ? (responseData.payoff_amount.principal || 0) : 100}
                        onChange={(e) => field.onChange((e.target.value > responseData.payoff_amount.principal) ? responseData.payoff_amount.principal : e.target.value)}
                      />
                    )}
                  />
                </td>
                <td className="pr-2 py-2">
                  <Controller
                    name={`interest_discount`}
                    control={control}
                    defaultValue={0}
                    render={({ field }) => (
                      <input
                        {...field}
                        {...register(`interest_discount`)}
                        name={`interest_discount`}
                        className="input is-small"
                        style={{ width: '125px' }}
                        type="number"
                        step="0.01"
                        form="payoff_payment_form"
                        disabled={responseData.payoff_amount.interest === 0}
                        max={discountType == 'amount' ? (responseData.payoff_amount.interest || 0) : 100}
                        onChange={(e) => field.onChange((e.target.value > responseData.payoff_amount.interest) ? responseData.payoff_amount.interest : e.target.value)}
                      />
                    )}
                  />
                </td>
                <td className="pr-2 py-2">
                  <Controller
                    name={`late_fee_discount`}
                    control={control}
                    defaultValue={0}
                    render={({ field }) => (
                      <input
                        {...field}
                        {...register(`late_fee_discount`)}
                        name={`late_fee_discount`}
                        className="input is-small"
                        style={{ width: '125px' }}
                        type="number"
                        step="0.01"
                        form="payoff_payment_form"
                        disabled={responseData.payoff_amount.late_fee === 0}
                        max={discountType == 'amount' ? (responseData.payoff_amount.late_fee || 0) : 100}
                        onChange={(e) => field.onChange((e.target.value > responseData.payoff_amount.late_fee) ? responseData.payoff_amount.late_fee : e.target.value)}
                      />
                    )}
                  />
                </td>
                <td className="pr-2 py-2">
                  <Controller
                    name={`nsf_fee_discount`}
                    control={control}
                    defaultValue={0}
                    render={({ field }) => (
                      <input
                        {...field}
                        {...register(`nsf_fee_discount`)}
                        name={`nsf_fee_discount`}
                        className="input is-small"
                        style={{ width: '125px' }}
                        type="number"
                        step="0.01"
                        form="payoff_payment_form"
                        disabled={responseData.payoff_amount.nsf_fee === 0}
                        max={discountType == 'amount' ? (responseData.payoff_amount.nsf_fee || 0) : 100}
                        onChange={(e) => field.onChange((e.target.value > responseData.payoff_amount.nsf_fee) ? responseData.payoff_amount.nsf_fee : e.target.value)}
                      />
                    )}
                  />
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  Discount Reason {showManagerApproval ? <span className="has-text-danger">*</span> : null}
                </td>
                <td colSpan={4}>
                  <Controller
                    name="discount_reason_dropdown_option_id"
                    control={control}
                    render={({ field }) => {
                      return (
                        <Select
                          {...field}
                          options={discountReasonOptions}
                          isSearchable={false}
                          classNames={reactSelectClassNames(errors, 'discount_reason_dropdown_option_id')}
                          menuPosition="fixed"
                          styles={{
                            container: (base) => ({ ...base, width: '100%' }),
                            menu: ({ ...css }) => ({ ...css, width: '100%' })
                          }}
                          form="payoff_payment_form"
                          isClearable
                        />
                      )
                    }}
                  />
                  {errors?.discount_reason_dropdown_option_id?.message &&
                    <p className="has-text-danger">{errors?.discount_reason_dropdown_option_id?.message}</p>}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div className="divider m-0 mx-1 mb-3"></div>
          <table className="table is-striped is-fullwidth">
            <tbody>
              <tr>
                <th>Principal</th>
                <th>Interest</th>
                <th>Late Fee</th>
                <th>NSF Fee</th>
                <th>Total</th>
              </tr>
              <tr>
                <td><CurrencyFormat
                  value={hasAgentDiscount ? responseData.payoff_amount.prediscount.principal - finalPrincipalDiscount : responseData.payoff_amount.postdiscount.principal}
                  showCents
                />
                  {((finalPrincipalDiscount && finalPrincipalDiscount > 0) || (!hasAgentDiscount && responseData.payoff_amount.prediscount.principal > responseData.payoff_amount.postdiscount.principal)) ? (
                    <span
                      className={'lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-right has-tooltip-primary has-text-weight-normal'}
                      data-tooltip={`Principal Amount: $${Number.parseFloat(finalPrincipalDiscount ? responseData.payoff_amount.prediscount.principal - finalPrincipalDiscount : responseData.payoff_amount.postdiscount.principal).toFixed(2)}\nPre-Discount Principal: $${responseData.payoff_amount.prediscount.principal}`}
                    >
                      <FontAwesomeIcon
                        icon={faInfo}
                        className="pl-1 has-text-link"
                        style={{ paddingBottom: '.15rem !important' }}
                      />
                    </span>
                  ) : null}</td>
                <td><CurrencyFormat
                  value={hasAgentDiscount ? responseData.payoff_amount.prediscount.interest - finalInterestDiscount : responseData.payoff_amount.postdiscount.interest}
                  showCents
                />
                  {((finalInterestDiscount && finalInterestDiscount > 0) || (!hasAgentDiscount && responseData.payoff_amount.prediscount.interest > responseData.payoff_amount.postdiscount.interest)) ? (
                    <span
                      className={'lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-right has-tooltip-primary has-text-weight-normal'}
                      data-tooltip={`Interest Amount: $${Number.parseFloat(finalInterestDiscount ? responseData.payoff_amount.prediscount.interest - finalInterestDiscount : responseData.payoff_amount.postdiscount.interest).toFixed(2)}\nPre-Discount Interest: $${responseData.payoff_amount.prediscount.interest}`}
                    >
                      <FontAwesomeIcon
                        icon={faInfo}
                        className="pl-1 has-text-link"
                        style={{ paddingBottom: '.15rem !important' }}
                      />
                    </span>
                  ) : null}</td>
                <td><CurrencyFormat
                  value={hasAgentDiscount ? responseData.payoff_amount.prediscount.late_fee - finalLateFeeDiscount : responseData.payoff_amount.postdiscount.late_fee}
                  showCents
                />
                  {((finalLateFeeDiscount && finalLateFeeDiscount > 0) || (!hasAgentDiscount && responseData.payoff_amount.prediscount.late_fee > responseData.payoff_amount.postdiscount.late_fee)) ? (
                    <span
                      className={'lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-right has-tooltip-primary has-text-weight-normal'}
                      data-tooltip={`Late Fee Amount: $${Number.parseFloat(finalLateFeeDiscount ? responseData.payoff_amount.prediscount.late_fee - finalLateFeeDiscount : responseData.payoff_amount.postdiscount.late_fee).toFixed(2)}\nPre-Discount Late Fee: $${responseData.payoff_amount.prediscount.late_fee}`}
                    >
                      <FontAwesomeIcon
                        icon={faInfo}
                        className="pl-1 has-text-link"
                        style={{ paddingBottom: '.15rem !important' }}
                      />
                    </span>
                  ) : null}</td>
                <td><CurrencyFormat
                  value={hasAgentDiscount ? responseData.payoff_amount.prediscount.nsf_fee - finalNSFFeeDiscount : responseData.payoff_amount.postdiscount.nsf_fee}
                  showCents
                />
                  {((finalNSFFeeDiscount && finalNSFFeeDiscount > 0) || (!hasAgentDiscount && responseData.payoff_amount.prediscount.nsf_fee > responseData.payoff_amount.postdiscount.nsf_fee)) ? (
                    <span
                      className={'lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-right has-tooltip-primary has-text-weight-normal'}
                      data-tooltip={`NSF Fee Amount: $${Number.parseFloat(finalNSFFeeDiscount ? responseData.payoff_amount.prediscount.nsf_fee - finalNSFFeeDiscount : responseData.payoff_amount.postdiscount.nsf_fee).toFixed(2)}\nPre-Discount NSF Fee: $${responseData.payoff_amount.prediscount.nsf_fee}`}
                    >
                      <FontAwesomeIcon
                        icon={faInfo}
                        className="pl-1 has-text-link"
                        style={{ paddingBottom: '.15rem !important' }}
                      />
                    </span>
                  ) : null}</td>
                <td><CurrencyFormat value={quote} /></td>
              </tr>
            </tbody>
          </table>
          <table className="table is-narrow table-payment-schedule-panel">
            <tbody>
              <tr>
                <td colSpan={3}>* Quote is correct assuming all pending payments clear successfully. Otherwise there will
                  be an outstanding balance owed.
                  {showManagerApproval ? <ManagerApprovalIcons type="mgr_approval_status_required" /> : null}
                </td>
                <td>
                  {quote && (
                    <div className="has-text-right">
                      <button
                        type="button"
                        className="button has-background-grey has-text-white is-small mr-1 ml-2"
                        onClick={() => checkChangesMade()}
                      >
                        <span className="mx-3">Cancel</span>
                      </button>
                      <button
                        type="button"
                        className="button is-link is-small mr-1"
                        onClick={() => clickConfirmation()}
                        disabled={(saving && 'disabled') || (enableScheduleButton == false && 'disabled')}
                      >
                        <span className="mx-3">{saving ? 'Scheduling' : 'Schedule'}</span>
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      )}
    </div>
  )
}
